import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { SecurityService } from '../../../services/security/security.service';
import { Router } from '@angular/router';
import { FormGroup } from "@angular/forms";
import { HttpErrorResponse } from '@angular/common/http';
import { MessagesTitles, MessagesStatus } from '../../../models/messages';
import Swal from "sweetalert2";

@Component({
  selector: 'app-listado-componente',
  templateUrl: './listado-componente.component.html',
  styleUrls: ['./listado-componente.component.scss'],
  providers: [MessagesTitles, MessagesStatus]
})
export class ListadoComponenteComponent implements OnInit {

  abrirPopUpComponente: boolean = false;
  form: FormGroup;
  user: any;
  ipAddress: any;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  pageSizeOptions = [10, 20, 30, 50, 100, 200];
  RepComponentes: any = [];
  loading: boolean = false;
  IdCuenta: string;
  data: any = {};

  displayedColumns: string[] =
    ['Checked', 'Sistema', 'Componente', 'Descripcion', 'Tipo_Componente', 'Ruta', 'Estado'];

  dataSource = new MatTableDataSource(this.RepComponentes);

  constructor(private securityService: SecurityService,
    private msgTitulos: MessagesTitles,
    private msgStatus: MessagesStatus,
    private router: Router) {

    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.ipAddress = JSON.parse(sessionStorage.getItem('PUBLIC-IP'));

    this.data.NombreProyecto = 'DigitalFactoring';
    this.data.Usuario = this.user.Usuario;
    this.data.Host = 'INTRANET';
    this.data.IP = this.ipAddress.ip;
    this.data.Canal = 'W';
  }

  ngOnInit() {
    this.ObtenerListaComponentes();
  }

  ObtenerListaComponentes() {
    this.loading = true;
    let tc = "";
    this.securityService.ObtenerListaComponentes(tc)
      .subscribe(resp => {
        this.RepComponentes = resp
        this.dataSource = new MatTableDataSource(this.RepComponentes);

        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.pageSizeOptions = [15, 20, 30, 50, 100, 200];
        this.loading = false;
      }, (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error(err);
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA COMPONENTES NO OBTENIDA. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      })

  }

  AgregarComponente() {
    this.securityService.dataComponente = '';
    this.abrirPopUpComponente = true;
  }

  EditarComponente(elemento: any) {
    this.securityService.dataComponente = elemento;
    this.abrirPopUpComponente = true;
  }

  EliminarComponente(element: any) {
    this.data.id_componente = element.id_componente;
    this.data.Estado = '0';

    Swal.fire({
      title: '',
      text: '¿Estás seguro de eliminar el id: ' + element.id_componente + '?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, dar de baja',
      cancelButtonText: 'No, cancelar.',
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        this.securityService.EliminarComponente(this.data)
          .subscribe(res => {
            Swal.fire({
              title: '¡El Componente ha sido dado de baja!',
              text: res["message"],
              type: 'success',
              heightAuto: false
            }).then(resp => {
              if (resp.value) {
                this.ngOnInit();
              }
            });
          }, (err: HttpErrorResponse) => {
            if (err.error instanceof ErrorEvent) {
              console.error(err);
            } else {
              this.msgStatus.getMessage(err.status);
            }
            Swal.fire({
              title: this.msgTitulos.Error,
              text: "NO SE ELIMINÓ COMPONENTE. " + this.msgStatus.message,
              type: "error",
              allowOutsideClick: true,
              heightAuto: false
            })
          })
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        this.loading = false;
      }
    });
  }

  CerrarPopUpComponente() {
    this.abrirPopUpComponente = false;
  }

  Refresh() {
    this.ngOnInit();
  }
}
